// extracted by mini-css-extract-plugin
module.exports =  {"taskDetailsCell":"style-module_taskDetailsCell__yJWAnRPULybta5yCxbaF","blockIcon":"style-module_blockIcon__CLrra2VI7vaqKTHaQr7r","cell":"style-module_cell__QGXTYoJ6MDPa9cpgWcTw"};